enum SignMethodType {
  INIT = 'INIT',
  MOBILE = 'MOBILE',
  EMAIL = 'EMAIL'
}
export default SignMethodType;
